
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M48.527 32.806c-1.1-2.4-3.2-2.2-5.4-2.2H26.827c0-.2-.1-.4-.2-.5-.2-.3-.3-.6-.5-.9.1-.3.3-.7.4-1 .1-.3.3-2.3-.5-1.9-.3.2-.6.3-.9.5l-.6.3s-.1.1-.2.1h-.2l-.6-.3c-.3-.1-.6-.3-.9-.4-.8-.3-.7 1.6-.5 1.9.2.4.4.7.6 1.1-.1.3-.3.7-.4 1v.1h-4c-1.9 0-4.7-.5-6.2 1-1.8 1.9-1.2 4.8.1 6.7 1.9 2.7 4.9 6.9 7.6 8.7.1.1.2.1.3.1v2.5c0 .3.1 1.1.5 1.1h18.6c.4 0 .6-.8.5-1.5v-1.9c3-3.3 11.1-9.5 8.8-14.5zm-21 14.9h11.3v.8h-17.6v-.9c1.9.5 4.3.1 6.3.1zm18.7-11.4c-1.4 2.9-4.9 5.7-7.1 8.2h-9.6c-2.2 0-7.5.5-8.7-.1-1.3-.7-2.6-3-3.6-4.1-1.1-1.3-3.3-3-3.9-4.5-1-2.7 3-2.1 4.7-2.1h24.5c.8 0 2.1-.3 2.8 0 3.3 1.2 1.5 1.3.9 2.6z"}}),_c('path',{attrs:{"d":"M33.227 26.006c0 1.4.8 3 2.3 3 1.5.1 2.2-1.1 2.4-2.4.1-.3.1-.5.1-.7 0-.1 0-.4-.1-.7-.2-1.2-.9-2.3-2.3-2.3-1.6.1-2.4 1.7-2.4 3.1zm2.3-.8c.3 0 .6 0 .9.2.1.1.6.4.6.6 0 .5-1.1.8-1.4.8-.4 0-1.4-.3-1.4-.8 0-.4 1-.7 1.3-.8zM24.527 22.406c1.5.1 2.2-1.1 2.4-2.4.1-.3.1-.5.1-.7 0-.1 0-.4-.1-.7-.2-1.2-.9-2.3-2.3-2.3-1.6 0-2.4 1.6-2.4 3 0 1.5.7 3 2.3 3.1zm0-3.8c.3 0 .6 0 .9.2.1.1.6.4.6.6 0 .5-1.1.8-1.4.8-.4 0-1.4-.3-1.4-.8 0-.4.9-.8 1.3-.8zM29.427 13.506c.6.2 1.1.5 1.7.7.1.5.3 1 .4 1.5.1.4.5.8.8.2.3-.4.5-1 .7-1.5.6-.2 1.1-.3 1.7-.5.5-.1.7-1.7.2-2.1 0-.1-.1-.1-.1-.1-.5-.2-1.1-.5-1.6-.7-.1-.5-.3-1-.4-1.5-.1-.4-.5-.8-.8-.2-.2.5-.5 1.1-.7 1.6-.6.2-1.1.3-1.7.5-.7.1-.8 1.8-.2 2.1zm3-1c-.1.2-.3.4-.4.7 0-.2 0-.4-.1-.5.1-.2.3-.4.4-.7 0 .2.1.3.1.5z"}})])
          )
        }
      }
    